// initialize tokenInterval
let tokenInterval: ReturnType<typeof setInterval> | undefined;

/**
 * Starts periodic session validation.
 */
export const startSessionValidation = (validateSession: () => void) => {
  // Initial check
  validateSession();

  tokenInterval = setInterval(validateSession, 5000);
};

/**
 * Stops periodic session validation.  This should be called when the component unmounts or when session validation is no longer required.
 */
export const stopSessionValidation = () => {
  if (tokenInterval !== undefined) {
    clearInterval(tokenInterval);
  }
};
